import styles from './Toast.module.scss';
import Text from '../../../common/component/Text';
import {IToastVariant} from '../../../common/type';

interface IProps {
  title?: string;
  desc: string;
  isClosing: boolean;
  variant?: IToastVariant;
  src?: string;
}

export default function Toast({
  title,
  desc,
  isClosing,
  variant = 'default',
  src,
}: IProps) {
  const {bgClassName, textClassName} = STYLE_MAP[variant];

  return (
    <div
      className={cn(
        styles.toast,
        bgClassName,
        'flex-col flex-center max-w-[335px] opacity-0 px-30 py-15 m-auto rounded-8',
        {
          [styles.closing]: isClosing,
        }
      )}
    >
      {src && <img src={src} alt="" className="mb-15" width={64} height={64} />}
      {!!title && (
        <Text className={cn(textClassName, 'mb-5 bg-tran text-center')}>
          {title}
        </Text>
      )}
      <Text className={cn(textClassName, 'text-center')}>{desc}</Text>
    </div>
  );
}

const STYLE_MAP: {
  [key in IToastVariant]: {
    bgClassName: string;
    textClassName: string;
  };
} = {
  default: {
    bgClassName: 'bg-white light:bg-black',
    textClassName: 's15-medium-black light:text-white',
  },
  black: {
    bgClassName: 'bg-black',
    textClassName: 's15-medium-white',
  },
  transparent: {
    bgClassName: 'bg-transparent',
    textClassName: 's14-regular-white',
  },
};
